import { Pipe, PipeTransform } from "@angular/core";
import { findById, mapToStringProp, StringKeys } from "./type-helpers";

@Pipe({
    name: 'mapToStringProp',
    standalone: true,
    pure: true,
  })
  export class MapToStringPropPipe implements PipeTransform {
    transform<T, K extends StringKeys<T>>(items: T[], prop: K): string[] {
      return mapToStringProp(items, prop);
    }
  }

@Pipe({
    name: 'stringInList',
    standalone: true,
    pure: true,
  })
  export class StringInListPipe implements PipeTransform {
    transform(list: string[], value:string, ignoreValue?:string): boolean {
      return (list.filter(item => item !== ignoreValue)).includes(value);
    }
  }

  @Pipe({
    name: 'findById',
    standalone: true,
    pure: true
  })
  export class FindByIdPipe implements PipeTransform {
    transform<K extends string, T extends { id: K }>(
      items: T[] | null | undefined,
      id: K | null | undefined
    ): T | undefined {
      if (!items || !id) return undefined;
      return findById(items, id);
    }
  }